import { Buildings, UserCircle } from "@phosphor-icons/react";

export const BrandPanel = () => (
  <div className="hidden lg:flex flex-col justify-between w-1/2 bg-[#2C3D30] text-white p-12">
    <img src="/dcn-logo.jpg" alt="DCN Food and Beverages" className="h-16 w-auto self-start rounded-lg" data-testid="login-logo" />
    <div>
      <h1 className="font-heading text-4xl sm:text-5xl font-extrabold leading-tight tracking-tight">People operations,<br />made simple.</h1>
      <p className="mt-4 text-stone-300 max-w-md">Attendance, leave, payroll and statutory exports for the DCN Foods workforce — on desktop and on the factory floor.</p>
    </div>
    <div className="text-sm text-stone-400">hrms.dcnfoods.com</div>
  </div>
);

export const PortalToggle = ({ portal, setPortal }) => (
  <div className="grid grid-cols-2 gap-2 p-1 bg-stone-100 rounded-full mb-8">
    <button type="button" onClick={() => setPortal("employer")} data-testid="portal-employer-tab"
      className={`flex items-center justify-center gap-2 py-3 rounded-full text-sm font-bold transition-colors duration-200 ${portal === "employer" ? "bg-white shadow-sm text-primary" : "text-stone-500"}`}>
      <Buildings size={18} weight="duotone" /> Employer
    </button>
    <button type="button" onClick={() => setPortal("employee")} data-testid="portal-employee-tab"
      className={`flex items-center justify-center gap-2 py-3 rounded-full text-sm font-bold transition-colors duration-200 ${portal === "employee" ? "bg-white shadow-sm text-primary" : "text-stone-500"}`}>
      <UserCircle size={18} weight="duotone" /> Employee
    </button>
  </div>
);
